import React from "react";
import { MessageCircle } from "lucide-react";
import {
  bulandiContactCoordinators,
  bulandiHelplineWhatsApp,
} from "../../data/bulandi2026Data";

function formatCoordinatorList(names) {
  if (!names.length) return "";
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} or ${names[1]}`;
  return `${names.slice(0, -1).join(", ")}, or ${names[names.length - 1]}`;
}

export function BulandiContactSection() {
  const waUrl = `https://wa.me/91${bulandiHelplineWhatsApp.digits10}`;
  const coordinatorNames = formatCoordinatorList(bulandiContactCoordinators);

  return (
    <section
      id="bulandi-contact"
      aria-label="Contact us"
      className="scroll-mt-6 rounded-2xl border-2 border-bul-border bg-bul-surface/90 p-5 shadow-bul-brutal-sm sm:p-6"
    >
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between lg:gap-8">
        <div className="min-w-0 flex-1">
          <h2 className="font-display text-[0.9375rem] uppercase tracking-tight text-bul-fg sm:text-[1.0625rem]">
            <span className="bul-heading-chrome">Contact </span>
            <span className="bul-text-gradient-fire">us</span>
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-bul-mutedfg sm:text-[0.9375rem]">
            For Bulandi queries, contact the SMYM helpline on WhatsApp at{" "}
            <a
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-bul-lime underline decoration-bul-lime/40 underline-offset-2 hover:text-bul-cyan"
            >
              {bulandiHelplineWhatsApp.display}
            </a>
            , or reach out to {coordinatorNames}.
          </p>
          <ul
            className="mt-3 flex flex-wrap gap-2"
            aria-label="Bulandi coordinators"
          >
            {bulandiContactCoordinators.map((name) => (
              <li
                key={name}
                className="rounded-full border border-bul-border bg-bul-bg/80 px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-wide text-bul-fg sm:text-xs"
              >
                {name}
              </li>
            ))}
          </ul>
        </div>
        <a
          href={waUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="bul-cta-primary inline-flex w-full shrink-0 items-center justify-center gap-2 px-5 py-3 text-sm sm:w-auto sm:min-w-[12.5rem]"
        >
          <MessageCircle className="h-4 w-4 shrink-0" aria-hidden />
          WhatsApp helpline
        </a>
      </div>
    </section>
  );
}
